import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import LinkNotification from './LinkNotification';
import { login } from '../../../../actions/authenticationActions';
import { ROUTE_LOGIN } from '../../../../constants/Routes';
import Spinner from '../../../common/spinner/Spinner';

@connect(
	({ authentication }) => ({
		email: authentication.email,
		regToken: authentication.regToken,
		loginProvider: authentication.loginProvider,
	}),
	{ login }
)
export default class LinkNotificationContainer extends Component {
	static propTypes = {
		email: PropTypes.string,
		regToken: PropTypes.string,
		loginProvider: PropTypes.string.isRequired,
	};

	componentDidMount() {
		const { email, regToken } = this.props;

		if (!email || !regToken) {
			this.props.history.push(ROUTE_LOGIN);
		}
	}

	render() {
		const { email, loginProvider, isLoading, missingFields } = this.props;

		return (
			<Fragment>
				{isLoading && (
					<div className="onboarding__container--loading">
						<Spinner />
					</div>
				)}
				{!isLoading && (
					<LinkNotification
						missingFields={missingFields}
						email={email}
						loginProvider={loginProvider}
					/>
				)}
			</Fragment>
		);
	}
}
